import React from "react";
import { Flex } from "../../atom/Flex";
function DivideLine() {
  return (
    <Flex height="16px" align="center" justify="center">
      <Flex color="offWhite" height="1px" width="343px" />
    </Flex>
  );
}

export default DivideLine;
